export const PAGE_SIZE_VIEW_ALL = 20

export const mapFilterActiveKey = {
  ALL: 'ALL',
  UNREAD: 'UNREAD',
}

export const SCREEN_TYPE = {
  VIEW_ALL: 'VIEW_ALL',
  POPUP: 'POPUP',
}

export const FILTER_LIST = [
  {
    label: 'systemNotifications.ALL',
    activeKey: mapFilterActiveKey.ALL,
  },
  {
    label: 'systemNotifications.UNREAD',
    activeKey: mapFilterActiveKey.UNREAD,
  },
]

export const getListAction = (isRead) => [
  {
    label: 'systemNotifications.DELETE',
    isI18n: true,
  },
  {
    label: `systemNotifications.${isRead ? 'MARK_AS_UNREAD' : 'MARK_AS_READ'}`,
    isI18n: true,
  },
]
